import AngryFace from '../Icons/components/emojis/AngryFace.js';
import SadFace from '../Icons/components/emojis/SadFace.js';
import StraightFace from '../Icons/components/emojis/StraightFace.js';
import HappyFace from '../Icons/components/emojis/HappyFace.js';
import StarstruckFace from '../Icons/components/emojis/StarstruckFace.js';

// Emojis
var Steps;
(function(Steps) {
    Steps["Emoji"] = "Emoji";
    Steps["Reason"] = "Reason";
    Steps["Conclusion"] = "Conclusion";
})(Steps || (Steps = {}));
var Feedback;
(function(Feedback) {
    Feedback["Horrible"] = "Horrible";
    Feedback["Bad"] = "Bad";
    Feedback["Okay"] = "Okay";
    Feedback["Great"] = "Great";
    Feedback["Awesome"] = "Awesome";
})(Feedback || (Feedback = {}));
const feedbackIconMap = {
    [Feedback.Horrible]: AngryFace,
    [Feedback.Bad]: SadFace,
    [Feedback.Okay]: StraightFace,
    [Feedback.Great]: HappyFace,
    [Feedback.Awesome]: StarstruckFace
};

export { Feedback, Steps, feedbackIconMap };
